import React, { memo } from "react";
import PropTypes from "prop-types";
import { Stack, Button, Icon } from "investira.react.components";

const ArquivosContextActions = memo((props) => {
  return (
    <Stack justifyContent="center" sx={{ height: "40px" }}>
      <Stack direction="row" alignItems="center">
        <Stack direction="row" spacing={1.5}>
          <Button
            disabled={props.disabled}
            variant="contained"
            color="error"
            startIcon={<Icon iconName="delete" size={16} />}
            size="small"
            sx={{ px: 2 }}
          >
            Excluir
          </Button>
        </Stack>
      </Stack>
    </Stack>
  );
});

ArquivosContextActions.propTypes = {
  disabled: PropTypes.bool,
  onUploadClick: PropTypes.func,
};

export default ArquivosContextActions;
